export const environment = {
  production: false,
  apiUrl: 'https://gstcrm.xstreamapps.in/',
  // apiUrl: 'http://10.10.18.4:81/',
  recaptchaMinimumScore: 0.5,
  recaptchaSiteKey: '6Le3oNssAAAAAOwX5eFEnXbWXQSJkfhQp3kqOsOe',
  // recaptchaSiteKey: '6Le_XNosAAAAAFgD-oRAFnHvLUGRkOPYxKYKhlU7', // local
  allowFileExtension: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
  allowExtesions: ['pdf', 'doc', 'docx'],
  maximumFileSize: 104857600,
};
